import script from "./ApiDocsContactUsProductExample.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiDocsContactUsProductExample.vue?vue&type=script&setup=true&lang=js"

import "./ApiDocsContactUsProductExample.vue?vue&type=style&index=0&id=340188ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340188ba"]])

export default __exports__